<template>

  <div class="disableScreen" v-if="true && tipo != 'warning'">

    <div class="errIconMsg">
      <div class="centered">
        <div v-if="tipo == 'error'">
          <svg width="122" height="112" viewBox="0 0 122 112" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path :fill="fillIcon" fill-rule="evenodd" clip-rule="evenodd" d="M78.8576 11.7752C75.2064 5.38249 68.3959 1.40884 61.0267 1.40013C53.6591 1.39142 46.845 5.34658 43.1449 11.7792L4.27633 78.8848C0.502174 85.2938 0.413843 93.3332 4.07479 99.8923C7.73657 106.453 14.5924 110.536 22.0503 110.6C22.052 110.6 22.0486 110.6 22.0503 110.6L99.8819 110.6C107.427 110.523 114.268 106.449 117.927 99.8982C121.584 93.3498 121.503 85.3282 117.712 78.8571L117.709 78.8512L78.8576 11.7752ZM99.889 112L22.0441 112C14.088 111.934 6.77353 107.579 2.86712 100.58C-1.03606 93.5868 -0.944896 85.0121 3.08476 78.1691L41.9462 11.0759C45.8947 4.2113 53.1663 -0.00927925 61.0283 1.53198e-05C68.8895 0.00930889 76.1585 4.24738 80.0585 11.0756L118.906 78.1443C122.948 85.0461 123.035 93.6018 119.134 100.586C115.228 107.579 107.928 111.921 99.889 112ZM22.0893 100.799C18.1487 100.766 14.4849 98.5847 12.5286 95.0796C10.5744 91.5784 10.62 87.2857 12.6375 83.8596L51.5277 16.7169C53.4972 13.2929 57.1094 11.1963 61.0153 11.2009C64.9208 11.2056 68.5317 13.3108 70.4685 16.7018L109.346 83.8235C111.384 87.3027 111.428 91.586 109.474 95.0828C107.518 98.5847 103.862 100.76 99.8349 100.799L22.0893 100.799ZM110.542 83.1152C110.543 83.1168 110.541 83.1137 110.542 83.1152C112.829 87.0228 112.879 91.8378 110.682 95.7708C108.48 99.7125 104.366 102.155 99.8484 102.199L99.8349 102.2L22.0779 102.199C17.6381 102.162 13.5195 99.7063 11.3209 95.7671C9.12532 91.8335 9.1729 87.0078 11.4433 83.1484C11.4442 83.1469 11.4424 83.1499 11.4433 83.1484L50.329 16.0136C50.3295 16.0126 50.3284 16.0145 50.329 16.0136C52.5468 12.1603 56.6166 9.79562 61.0169 9.80082C65.4129 9.80602 69.4811 12.1741 71.6673 15.9986C71.668 15.9998 71.6666 15.9974 71.6673 15.9986L110.542 83.1152ZM61.0054 88.198C63.3038 88.198 65.1662 86.317 65.1662 83.9977C65.1662 81.6783 63.3038 79.7973 61.0054 79.7973C58.707 79.7973 56.8446 81.6783 56.8446 83.9977C56.8446 86.317 58.707 88.198 61.0054 88.198ZM65.1826 34.9936H56.8609V71.3966H65.1826V34.9936ZM66.5526 83.9977C66.5526 87.0907 64.069 89.5981 61.0054 89.5981C57.9418 89.5981 55.4582 87.0907 55.4582 83.9977C55.4582 80.9046 57.9418 78.3972 61.0054 78.3972C64.069 78.3972 66.5526 80.9046 66.5526 83.9977ZM66.5689 33.5935V72.7968H55.4746V33.5935H66.5689Z"/>
          </svg>
        </div>
        <div v-if="tipo == 'info'">
          <svg width="103" height="101" viewBox="0 0 103 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path :stroke="fillIcon" stroke-width="2" d="M44.7618 28.6025C46.0212 25.8945 48.813 24.2097 51.8244 24.3403V24.3565C55.8621 24.4969 59.0284 27.8334 58.9136 31.827C58.8477 34.8069 56.9642 37.4509 54.1488 38.5157C51.3335 39.5806 48.1464 38.8544 46.0861 36.6787C44.0259 34.5029 43.5024 31.3106 44.7618 28.6025Z"/>
            <path :stroke="fillIcon" stroke-width="2" d="M42.8947 42.6751H56.0504C56.6394 42.6238 57.2248 42.8056 57.6748 43.1796C58.1247 43.5535 58.4014 44.0882 58.4424 44.6632C58.6546 45.7032 58.4405 46.6878 58.2264 47.6727C58.174 47.9136 58.1217 48.1545 58.0755 48.3962C57.2146 52.8873 56.3659 57.376 55.5295 61.8623C55.4388 62.3465 55.3442 62.8308 55.2496 63.3154C55.0229 64.4768 54.7957 65.6404 54.6197 66.8111C54.54 67.4828 54.5622 68.1623 54.6857 68.8278C54.7347 69.4233 55.0494 69.968 55.5465 70.3176C56.0436 70.6672 56.6731 70.7866 57.2684 70.6442C58.0067 70.4808 58.7249 70.2411 59.4109 69.9291C59.659 69.8233 59.898 69.6907 60.1366 69.5582C60.4625 69.3773 60.7878 69.1967 61.1352 69.0852C61.518 68.9517 61.9425 68.9965 62.2871 69.2068C62.5723 69.5849 62.6839 70.0614 62.5953 70.5227C62.4138 71.0507 62.0983 71.5255 61.6781 71.9029C59.3647 74.2996 56.1396 75.6605 52.7633 75.6645C51.1878 75.6825 49.6132 75.5844 48.0528 75.3713C45.4187 74.9422 42.1023 71.6883 42.6819 68.2199C42.8748 67.0733 43.0559 65.9252 43.2371 64.777C43.4627 63.3472 43.6884 61.9171 43.9366 60.4892C44.1738 59.1175 44.4252 57.7485 44.6766 56.3799C45.1249 53.9386 45.573 51.4987 45.9397 49.047C46.2479 47.0017 45.4261 46.1292 43.3863 46.0363C42.611 45.9697 41.8535 45.7713 41.1485 45.4499C40.5693 45.1977 40.2598 44.5762 40.4147 43.9767C40.498 43.4248 40.9258 42.9822 41.486 42.8682C41.9449 42.7443 42.4185 42.6794 42.8947 42.6751Z"/>
            <rect :stroke="fillIcon" stroke-width="2" x="8" y="7" width="87" height="86" rx="43"/>
            <path :stroke="fillIcon" stroke-width="2" d="M102 50.5C102 77.8197 79.409 100 51.5 100C23.591 100 1 77.8197 1 50.5C1 23.1803 23.591 1 51.5 1C79.409 1 102 23.1803 102 50.5Z"/>
          </svg>
        </div>
        {{messageErr}}
      </div>
    </div>
    <div class="errDetail">
      <div class="centered">
        <div>{{detailErr}}</div>
        <div class="space"></div>
      </div>
    </div>

  </div>

  <div class="disableScreen" v-if="true && tipo == 'warning'">

    <div class="errIconMsg2">
      <div class="centered">
      </div>
    </div>
    <div class="errDetail2">
      <div>
        <div class="space2"></div>
        <div class="errIconMsgFont">{{messageErr}}</div>
        <div class="space2"></div>
        <div style="margin-bottom: 20px">{{detailErr}}</div>
        <Okbutton
          rotulo="Ok"
          tipo="submit"
          :confirmacao="false"
          @botaoAtivado="disable()"
        />
      </div>
    </div>

  </div>

</template>

<script>

export default {
  props: {
    tipo: String,
    messageErr: String,
    detailErr: String
  },
  data() {
    return {
      showModal: false,
      fillIcon: 'var(--exceptions-icons-color)',
    }
  },
  methods: {
    enable(){
      this.showModal = true;
    },
    disable(){
      this.showModal = false;
    }
  }
}
</script>

<style scoped>
.disableScreen{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--exceptions-backgroundup-transparency-color);
}
.errIconMsg, .errIconMsg2, .errDetail, .errDetail2{
  text-align: center;
  width: 100%;
}
.errIconMsg{
  height: 60%;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  color: var(--exceptions-title-color);
}
.errIconMsg2{
  height: 40%;
}
.errIconMsgFont {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  color: var(--exceptions-title-color);
}
.errDetail, .errDetail2{
  font-size: 18px;
  line-height: 24px;
  color: var(--exceptions-text-color);
  background-color: var(--exceptions-backgrounddown-solid-color);
  border-radius: 40px 40px 0px 0px;
  border-top: 0.5px solid var(--exceptions-icons-color);
}
.errDetail{
  height: 40%;
}
.errDetail2{
  height: 60%;
}
.centered{
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}
.space{
  padding: none;
  margin: none;
  height: 40%;
}
.space2{
  padding: none;
  margin: none;
  height: 40px;
}
</style>